import React, {useEffect, useState} from 'react';
import {postIsPassword} from "../../api/apiClient";
import {Col, Form, Row} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Swal from "sweetalert2";

const PasswordCheck = ({
                         hClose,
                         propUserId,
                         propSetPopup,
                         propHandleOpenPopup,
                         propType,
                         propDelItemFunc
                       }) => {

  const [type, setType] = useState("reg");

  useEffect(() => {
    console.log(propType);
    setType(propType);
  }, [propType]);

  const [password, setPassword] = useState('');

  const check = () => {
    // console.log("hi");
    postIsPassword(password)
        .then((res) => {
          console.log(res);
          // console.log(res.data.data.isValid);
          if (res.data.data.isValid === true) {
            if (type === "reg") {
              hClose();
              propSetPopup({
                isVisible: true,
                user_id: propUserId,
              });
            } else if (type === "del") {
              console.log("del");
              hClose();
              // propHandleOpenPopup();
              propDelItemFunc(propUserId);
            }
          } else {
            Swal.fire('비밀번호를 확인해주세요.');
          }
        })
        .catch((err) => {
          Swal.fire(
              err.response.data.message,
              '',
              'error'
          );
        });
  };

  return (
      <Container fluid className={"layer p-2"}>
        <Row className={""}>
          <Col className={''}>
            <Row className={'info-container py-2 mx-3'}>
              <Col md={11} className={'px-5'}>
                <div className={'content-container-body-item'}>
                  <Form
                      className={'password-check-form py-3'}
                      id={'passwordCheckForm'}
                  >
                    <Row className={"justify-content-center"}>
                      <Col md={12} className={"mb-3"}>
                        <Form.Group as={Row} controlId='password'>
                          <Form.Label column md={3} className={'label text-end'}>
                            비밀번호
                          </Form.Label>
                          <Col md={9}>
                            <Form.Control
                                type="password"
                                className={'input text-white'}
                                onChange={(e) => {
                                  setPassword(e.target.value);
                                }}
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Form>
                </div>
              </Col>
            </Row>
            <Row className={"my-3 justify-content-center"}>
              <Col md={2} className={'justify-content-center'}>
                <Button type={"button"} className={'btn save-btn w-100'}
                        onClick={check}>
                  확인
                </Button>
              </Col>
              <Col md={2} className={'justify-content-center text-end'}>
                <Button type={"button"} className={'btn btn-secondary w-100'}
                        onClick={hClose}>
                  취소
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
  );
};

export default PasswordCheck;
